module.exports = __webpack_public_path__ + "img/choose_1.fa05c0ea.png";